// Imports for external libraries go here.
import React, { FC } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { CarouselGalleryTriptychProps } from './CarouselGallery.types';
import { StyledCarouselGalleryTriptych } from './CarouselGallery.styles';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import clsx from 'clsx';
import { CarouselGallery as CarouselGalleryComp } from '@marriott/mi-ui-library';
import { DARK_COLOR_SCHEME } from '../../modules/constants/constant';

// Use named rather than default exports.
export const CarouselGalleryTriptych: FC<CarouselGalleryTriptychProps> = (props: CarouselGalleryTriptychProps) => {
  const regex = new RegExp(DARK_COLOR_SCHEME);
  return (
    <div className={props?.styleclass}>
      <StyledCarouselGalleryTriptych
        data-testid="luxury-CarouselGalleryTriptych"
        data-component-name="m-luxury-CarouselGalleryTriptych"
        className="container"
      >
        <CarouselGalleryComp
          {...props}
          customClass={clsx(props?.styleclass && regex.test(props?.styleclass) && 'color-class')}
          btnCustomClass={clsx(props?.previousLabel && props?.nextLabel && 't-font-xs')}
        />
      </StyledCarouselGalleryTriptych>
    </div>
  );
};

export const CarouselGalleryTriptychConfig = {
  emptyLabel: 'LuxuryCarouselGalleryTriptych',
  isEmpty: () => true,
  resourceType: `mi-aem-common-spa/components/content/carouselgallery`,
};

export const CarouselGallery = (props: CarouselGalleryTriptychProps) => (
  <div
    data-testid="luxury-CarouselGalleryTriptych"
    data-component-name="m-luxury-CarouselGalleryTriptych"
    className="m-container-fullbleed"
  >
    <EditableComponent config={CarouselGalleryTriptychConfig} {...props}>
      <CarouselGalleryTriptych {...props} />
    </EditableComponent>
  </div>
);
